import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  getDocumentTypeBySlug,
  SchemaQueryKeys,
  type DocumentTypeResponse,
} from '../api';

/**
 * Fetches a single document type by slug.
 *
 * The API always returns the head (versioning is automatic and invisible to the
 * editor). The `prefer` option is kept for call-site backwards compatibility but
 * is no longer sent to the server.
 */
export function useDocumentType(
  slug: string | undefined,
  _options: Record<string, unknown> = {},
): UseQueryResult<DocumentTypeResponse> {
  return useQuery({
    queryKey: SchemaQueryKeys.detail(slug ?? ''),
    queryFn: ({ signal }) => getDocumentTypeBySlug(slug as string, { signal }),
    enabled: slug !== undefined && slug !== '',
  });
}
